import React from "react";
import { Button } from "reactstrap";
import cx from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMessage,faEye,faCheck, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Progress } from "react-sweet-progress";
import Icon from "../../../components/Icon";
import OptionsBtn from "../../../components/OptionsButton";
import {getInitials} from "../../../utils/common";
import { useUsersContext } from "../../../../../Components/Inbox/context/usersContext";
import requestApi from "../../../../../services/requestApi.service";
import {getLeadFieldName, showToast, getOpenChatCount, loadContactsData, parseJSON, getSessionValue, handleErrorResponse, mobileNumberMusk, isMobile} from "../../../../../Common/Appcommon";
import CratioTooltip from "../../../../../Common/CratioTooltip";

const Header = ({ user, profileSidebarStatus, openProfileSidebar, openSearchSidebar, refreshChat,remainingTime,remainingPercentage, openChatList }) => {
	
	const {loadUsers} = useUsersContext();

	const updateChatStatus = async (id) => {

		let status = "Closed";
		let msg = "Changed the conversation status as RESOLVED!";
		let filterOption = parseJSON(getSessionValue("filterOption"));
		if(user.wsapp_convo_status !== null && user.wsapp_convo_status.toLowerCase() === 'closed'){
			status = "Open";
			msg = "Changed the conversation status as OPEN!";
		}

		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "CHATSTATUS",
			"STATUS" : status,
			"formid" : id,
			"isOtherApiReq" : true,
		}
		let response = await requestApi.processServerRequest(params);
		if (response.issuccess){
			if(status === "Closed"){
				showToast(msg,'top-right','success',function () {
					refreshChat();
				}, 1000);
			}else if(status === "Open"){
				let result = await loadContactsData(filterOption);
				if(result.issuccess){
					let contacts = result.data;
					loadUsers(contacts);
					getOpenChatCount(contacts);
					showToast(msg,'top-right','success',1000);
				}
			}
		}else{
            handleErrorResponse(response.errormsg);
        }
	}

	const contactName = "Contact_Name";//getLeadFieldName('contactname');
	const mobile = "Mobile";//getLeadFieldName('mobile');
	let showCloseChat = true;

	if(user.wsapp_convo_status !== null && user.wsapp_convo_status.toLowerCase() === 'closed'){
		showCloseChat = false;
	}

	let userMobile = user[mobile];
	userMobile = mobileNumberMusk(userMobile);
	let isMobileScreen = isMobile();
	return (
		<header className="header chat__header">
			{isMobileScreen && 
				<div onClick={openChatList} className="chat__backbtn">
					<FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/>
				</div>
			}
			<div className="chat__avatar-wrapper" onClick={openProfileSidebar}>
			<span className="roundCircle">{getInitials(user[contactName])}</span>
				{/* <img src={user.profile_picture} alt={user?.name} className="avatar" /> */}
			</div>

			<div className="chat__contact-wrapper" onClick={openProfileSidebar}>
			<CratioTooltip
					id={'contact_name'}
					title={user[contactName]}
					placement={`bottom-start`}
					content={
						<h2 className={cx("chat__contact-name chat_inbox_leadname_width")}> {user[contactName]}</h2>
					}
				/>
				<p className={'chat__contact-desc'}>
					{userMobile}
				</p>
				{/* <p className="chat__contact-desc">
					{user.typing ? "typing..." : "online"}
				</p> */}
			</div>
			<div className="chat__actions">
				<CratioTooltip
					id={'chat_timer'}
					title={`Time remaining for the 24h conversation window. WhatsApp allows open chat for 24 h after a user initiated response, beyond which you can only send approved templates or wait till the user initiates a message.`}
					placement={`bottom`}
					content={
						<div className={`mr-1 wp-progress`}>
							<Progress
								type="circle"
								width={38}
								percent={remainingPercentage}
								status="default"
								strokeWidth={10}
								theme={{
									default: {
										symbol: remainingTime,
										color: '#58cd91',
										trailColor: '#d9d9d9'
									}
								}}
							/>
						</div>
				} />
				<CratioTooltip
					id={'chat_resolve'}
					title={showCloseChat ? `Current open conversation will be moved to resolve. You can use filters to see all resolved chats.` : ''}
					placement={`bottom`}
					content={
						<Button className={cx({'open_chat_btn' : !showCloseChat})} onClick={() => updateChatStatus(user.cid)} color="success">
							{ <FontAwesomeIcon className={``} icon={showCloseChat ? faCheck : faMessage}/> }
							{ showCloseChat ? ` Resolve` : ` Reopen` }
						</Button>
					}
				/>
				{!isMobileScreen && 
				<Button className={'ml-1'} onClick={() => openProfileSidebar()} color="success">
					<FontAwesomeIcon className={'cursor-pointer'} icon={faEye}/> Contact Info
				</Button>
				}
				<button
					className="chat__action hide"
					aria-label="Search"
					onClick={openSearchSidebar}
				>
					<Icon
						id="search"
						className="chat__action-icon chat__action-icon--search"
					/>
				</button>
				<OptionsBtn
					className="chat__action hide"
					ariaLabel="Menu"
					iconId="menu"
					iconClassName="chat__action-icon"
					options={[
						"Contact Info",
						"Select Messages",
						"Mute notifications",
						"Clear messages",
						"Delete chat",
					]}
				/>
			</div>
		</header>
	);
};

export default Header;
